export default () => process.env.SIMORGH_APP_ENV === 'live';
